export interface IAppItem {
  appName: string
  appId: string
}
export interface IIdentytyItem {
  enterpriseName: string
  enterpriseId: string
}

export enum LoginBodyCodeEnum {
  /** 验证通过 */
  VALID = '1',
  /** 无企业身份或账户、密码验证不通过 */
  NO_IDENTITY_OR_NOT_VALID = '3',
  /** 验证码错误 */
  VERIFICATION_CODE_ERROR = '4',
  /** 登录成功，但无身份匹配信息 */
  VALID_WITH_NOT_IDENTITY = '5',
  /** 多身份 */
  MULTI_IDENTITY = '6',
  /** 冻结账户 */
  FROZEN_ACCOUNT = '12',
  /** 未绑定手机号 */
  NO_BINDING_PHONE = '10',
  /** 图形验证码错误 */
  SLIDE_CAPTCHA_ERR = '100',
  /** 只有云校企业身份，提示没有权限 */
  NO_PERMISSION = '1200003',
  /** 用户已经在PC直播端登录 */
  ACCOUNT_LOGIN_ANOTHER = '17'
}

export interface IIdentytyItem {
  enterpriseName: string
  enterpriseId: string
  empId: string
}
export interface IIdentytySelectItem {
  title: string
  value: string
  empId: string
}

export enum CaptEnum {
  /* 账密登录 202 */
  NORMAL_LOGIN = '202',
  /* 免密登录 201 */
  FREE_LOGIN = '201',
  /* 课程打卡 800 */
  COURSE = '800',
}

export type SlideParamsType = {
  isSlideValidate: string
  slideChallenge: string
  slideSecCode: string
  slideValidate: string
  type: string
}
